<div class="demo">
  <pa-info-block blockTitle="Обычный">
    <div class="box">
      <pa-button label="Primary"></pa-button>
      <pa-button label="Secondary" severity="secondary"></pa-button>
      <pa-button label="Info" severity="info"></pa-button>
      <pa-button label="Success" severity="success"></pa-button>
      <pa-button label="Warn" severity="warn"></pa-button>
      <pa-button label="Danger" severity="danger"></pa-button>
      <pa-button label="Help" severity="help"></pa-button>
    </div>
  </pa-info-block>

  <pa-info-block blockTitle="Кнопки с иконками">
    <div class="box">
      <pa-button icon="pi pi-home" label="Primary"></pa-button>
      <pa-button icon="pi pi-user" label="Secondary" severity="secondary"></pa-button>
      <pa-button icon="pi pi-home" label="Info" severity="info"></pa-button>
      <pa-button icon="pi pi-home" label="Success" severity="success"></pa-button>
      <pa-button icon="pi pi-home" label="Warn" severity="warn"></pa-button>
      <pa-button icon="pi pi-home" label="Danger" severity="danger"></pa-button>
      <pa-button icon="pi pi-home" label="Help" severity="help"></pa-button>
    </div>
  </pa-info-block>

  <pa-info-block blockTitle="Кнопки с обводкой">
    <div class="box">
      <pa-button label="Primary" variant="outlined"></pa-button>
      <pa-button label="Secondary" severity="secondary" variant="outlined"></pa-button>
      <pa-button label="Info" severity="info" variant="outlined"></pa-button>
      <pa-button label="Success" severity="success" variant="outlined"></pa-button>
      <pa-button label="Warn" severity="warn" variant="outlined"></pa-button>
      <pa-button label="Danger" severity="danger" variant="outlined"></pa-button>
      <pa-button label="Help" severity="help" variant="outlined"></pa-button>
    </div>
  </pa-info-block>

  <pa-info-block blockTitle="Только иконки без фона">
    <div class="box">
      <pa-button icon="pi pi-home" variant="text"></pa-button>
      <pa-button icon="pi pi-user" variant="text" severity="secondary"></pa-button>
      <pa-button icon="pi pi-home" variant="text" severity="info"></pa-button>
      <pa-button icon="pi pi-home" variant="text" severity="success"></pa-button>
      <pa-button icon="pi pi-home" variant="text" severity="warn"></pa-button>
      <pa-button icon="pi pi-home" variant="text" severity="danger"></pa-button>
      <pa-button icon="pi pi-home" variant="text" severity="help"></pa-button>
    </div>
  </pa-info-block>

  <pa-info-block blockTitle="Только иконки с фоном">
    <div class="box">
      <pa-button icon="pi pi-home"></pa-button>
      <pa-button icon="pi pi-user" severity="secondary"></pa-button>
      <pa-button icon="pi pi-home" severity="info"></pa-button>
      <pa-button icon="pi pi-user" severity="secondary"></pa-button>
      <pa-button icon="pi pi-home" severity="success"></pa-button>
      <pa-button icon="pi pi-home" severity="warn"></pa-button>
      <pa-button icon="pi pi-home" severity="danger"></pa-button>
      <pa-button icon="pi pi-home" severity="help"></pa-button>
    </div>
  </pa-info-block>

  <pa-info-block blockTitle="Текстовые кнопки">
    <div class="box">
      <pa-button label="Primary" variant="text"></pa-button>
      <pa-button label="Secondary" severity="secondary" variant="text"></pa-button>
      <pa-button label="Info" severity="info" variant="text"></pa-button>
      <pa-button label="Success" severity="success" variant="text"></pa-button>
      <pa-button label="Warn" severity="warn" variant="text"></pa-button>
      <pa-button label="Danger" severity="danger" variant="text"></pa-button>
      <pa-button label="Help" severity="help" variant="text"></pa-button>
    </div>
  </pa-info-block>

  <pa-info-block blockTitle="Ссылка кнопки">
    <div class="box">
      <pa-button label="Primary" [link]="true"></pa-button>
      <pa-button label="Secondary" severity="secondary" [link]="true"></pa-button>
      <pa-button label="Info" severity="info" [link]="true"></pa-button>
      <pa-button label="Success" severity="success" [link]="true"></pa-button>
      <pa-button label="Warn" severity="warn" [link]="true"></pa-button>
      <pa-button label="Danger" severity="danger" [link]="true"></pa-button>
      <pa-button label="Help" severity="help" [link]="true"></pa-button>
    </div>
  </pa-info-block>

  <pa-info-block blockTitle="Группа кнопок">
    <p-buttongroup>
      <p-button [rounded]="true" label="Сохранить" icon="pi pi-check" />
      <p-button [rounded]="true" label="Удалить" icon="pi pi-trash" />
      <p-button [rounded]="true" label="Отмена" icon="pi pi-times" />
    </p-buttongroup>
    <br />
    <p-buttongroup>
      <p-button [rounded]="true" label="Сохранить" icon="pi pi-check" severity="secondary" />
      <p-button [rounded]="true" label="Удалить" icon="pi pi-trash" severity="secondary" />
      <p-button [rounded]="true" label="Отмена" icon="pi pi-times" severity="secondary" />
    </p-buttongroup>
  </pa-info-block>

  <pa-info-block blockTitle="Размеры">
    <div class="box">
      <pa-button label="Secondary" size="small" severity="secondary"></pa-button>
      <pa-button label="Secondary" severity="secondary"></pa-button>
      <pa-button label="Secondary" size="large" severity="secondary"></pa-button>
    </div>
    <div class="box">
      <pa-button size="small" icon="pi pi-home"></pa-button>
      <pa-button size="small" icon="pi pi-home" label="Primary"></pa-button>
      <br /><br />
      <pa-button icon="pi pi-home"></pa-button>
      <pa-button icon="pi pi-home" label="Primary"></pa-button>
      <br /><br />
      <pa-button size="large" icon="pi pi-home"></pa-button>
      <pa-button size="large" icon="pi pi-home" label="Primary"></pa-button>
    </div>
  </pa-info-block>

  <pa-info-block blockTitle="Квадратные">
    <div class="box">
      <pa-button label="Primary" size="small" [rounded]="false"></pa-button>
      <pa-button label="Primary" [rounded]="false"></pa-button>
      <pa-button label="Primary" size="large" [rounded]="false"></pa-button>
    </div>
  </pa-info-block>

  <pa-info-block blockTitle="ПРОФИ">
    <div class="box">
      <pa-button label="Попробовать 14 дней" size="large" severity="profi"></pa-button>
      <pa-button label="Попробовать 14 дней" severity="profi"></pa-button>
      <pa-button label="Попробовать 14 дней" size="small" severity="profi"></pa-button>
    </div>
  </pa-info-block>

  <pa-info-block blockTitle="Кнопки с бейджами">
    <div class="box">
      <pa-button
        label="Info"
        severity="info"
        [badge]="100"
        variant="outlined"
      ></pa-button>
      <pa-button
        label="Messages"
        icon="pi pi-users"
        [badge]="100"
        badgeSeverity="contrast"
        variant="outlined"
      ></pa-button>
      <pa-button
        label="More than 99"
        icon="pi pi-inbox"
        [badge]="1"
        badgeSeverity="warn"
      ></pa-button>
      <pa-button
        label="Profi с бейджем"
        severity="profi"
        [badge]="12"
        badgeSeverity="contrast"
      ></pa-button>
    </div>
  </pa-info-block>

<p><b>Кнопки с бейджами</b></p>
<div class="box">
  <pa-button 
    label="Info"
    severity="info"
    [badge]="100"
    variant="outlined"
  ></pa-button>
  <pa-button  
    label="Messages"
    icon="pi pi-users"
    [badge]="100"
    badgeSeverity="contrast"
    variant="outlined"
  ></pa-button>
  <pa-button
    label="More than 99"
    icon="pi pi-inbox"
    [badge]="1"
    badgeSeverity="warn"
  ></pa-button>
  <pa-button
    label="Profi с бейджем"
    severity="profi"
    [badge]="12"
    badgeSeverity="contrast"
  ></pa-button>
</div>

<p><b>Disabled</b></p>
<div class="box">
  <pa-button label="Primary" [disabled]="true"></pa-button>
  <pa-button label="Secondary" severity="secondary" [disabled]="true"></pa-button>
  <pa-button label="Info" severity="info" [disabled]="true"></pa-button>
  <pa-button label="Success" severity="success" [disabled]="true"></pa-button>
  <pa-button label="Warn" severity="warn" [disabled]="true"></pa-button>
  <pa-button label="Danger" severity="danger" [disabled]="true"></pa-button>
  <pa-button label="Help" severity="help" [disabled]="true"></pa-button>
</div>

<p><b>Disabled с иконками</b></p>
<div class="box">
  <pa-button icon="pi pi-home" label="Primary" [disabled]="true"></pa-button>
  <pa-button icon="pi pi-user" label="Secondary" severity="secondary" [disabled]="true"></pa-button>
  <pa-button icon="pi pi-home" label="Info" severity="info" [disabled]="true"></pa-button>
  <pa-button icon="pi pi-home" label="Success" severity="success" [disabled]="true"></pa-button>
  <pa-button icon="pi pi-home" label="Warn" severity="warn" [disabled]="true"></pa-button>
  <pa-button icon="pi pi-home" label="Danger" severity="danger" [disabled]="true"></pa-button>
  <pa-button icon="pi pi-home" label="Help" severity="help" [disabled]="true"></pa-button>
</div>
  
  <pa-info-block blockTitle="Клик-зона pa-button">
    <div class="box">
      <pa-button
        class="pa-button-host-debug"
        label="Клик normal"
        (click)="handlePaButtonClick('normal')"
      ></pa-button>
      <pa-button
        class="pa-button-host-debug pa-button-host-debug--full-width"
        label="Клик fullWidth"
        [fullWidth]="true"
        (click)="handlePaButtonClick('fullWidth')"
      ></pa-button>
      <pa-button
        class="pa-button-host-debug pa-button-host-debug--forced-width"
        label="Клик forced width (без fullWidth)"
        (click)="handlePaButtonClick('forced-width')"
      ></pa-button>
    </div>

    <div class="click-zone-box click-zone-box--wide">
      <pa-button
        class="pa-button-host-debug"
        label="Клик в широком блоке"
        (click)="handlePaButtonClick('narrow-in-wide-block')"
      ></pa-button>
    </div>

    <p class="click-zone-hint">
      Синяя рамка — блок-контейнер, красная — host pa-button. Клик справа от кнопки внутри синей зоны не должен срабатывать.
    </p>

    @if (lastClickedLabel) {
      <p class="click-result">
        Последний клик: {{ lastClickedLabel }}
      </p>
    }
  </pa-info-block>
</div>
